import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  january_rate: {
    name: 'January'
  },
  february_rate: {
    name: 'February'
  },
  march_rate: {
    name: 'March'
  },
  april_rate: {
    name: 'April'
  },
  may_rate: {
    name: 'May'
  },
  june_rate: {
    name: 'June'
  },
  july_rate: {
    name: 'July'
  },
  august_rate: {
    name: 'August'
  },
  september_rate: {
    name: 'September'
  },
  october_rate: {
    name: 'October'
  },
  november_rate: {
    name: 'November'
  },
  december_rate: {
    name: 'December'
  }
};

const _tables = [
  {
    name: 'Percentage of gross investment returns',
    order: 219,
    columnLables,
    key: 'GROSS'
  },
  {
    name: 'Percentage of net investment returns',
    order: 231,
    columnLables,
    key: 'NET'
  },
  {
    name: 'Percentage of NAV change',
    order: 243,
    columnLables,
    key: 'NAV_CHANGE'
  }
];

export function HistoricalProfile({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.HISTORICAL_PROFILE,
    onChangeFund,
    schema: schema.HISTORICAL_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.HISTORICAL_PROFILE?.field_names || [],
    tableName: 'HISTORICAL_PROFILE',
    tables: _tables,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="reporttables-historical-profile-group">
      {tables.map((rows, index) => (
        <Table
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
          key={index + 'HISTORICAL_PROFILE'}
          id={`reporttables-historical-profile-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
        />
      ))}
    </StyledTables>
  );
}
